// src/modules/components/sticky-steps.js
import { ScrollTrigger } from "@lib/gsap";

export function initStickyStepsBasic() {
  const containers = document.querySelectorAll("[data-sticky-steps-init]");
  if (!containers.length) return;

  containers.forEach((container) => {
    if (container.dataset.scriptInitialized) return;
    container.dataset.scriptInitialized = "true";

    const items = [...container.querySelectorAll("[data-sticky-steps-item]")];
    if (!items.length) return;

    function setActiveStep(activeIndex) {
      items.forEach((item, index) => {
        let status = "active";
        if (index < activeIndex) status = "before";
        if (index > activeIndex) status = "after";
        item.setAttribute("data-sticky-steps-item-status", status);
      });
    }

    items.forEach((item, index) => {
      const anchor = item.querySelector("[data-sticky-steps-anchor]");
      if (!anchor) return;

      ScrollTrigger.create({
        trigger: anchor,
        start: "top center",
        onEnter: () => setActiveStep(index),
        onLeaveBack: () => setActiveStep(Math.max(0, index - 1)),
      });
    });

    setActiveStep(0);
  });
}
